<template>
  <div>
    <v-row>
      <v-col cols="4">
        <Users @selection-changed="handleSelectionChanged" />
      </v-col>
      <v-col cols="8">
        <GridDrepturiUtilizatori v-if="selectedRow !== null && selectedRow !== undefined" :key="selectedRow"
          :user-id="selectedRow" />

      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import Users from '../ADMIN/Users.vue';
import GridDrepturiUtilizatori from './GridDrepturiUtilizatori.vue';

export default {
  name: 'PaginaUtilizatori',
  components: { GridDrepturiUtilizatori, Users },
  data() {
    return {
      selectedRow: null as number | null,
    };
  },
  methods: {
    handleSelectionChanged(row: any) {
      this.selectedRow = row?.ID ?? row?.id ?? null;
    },
  },
};
</script>
